exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-section {\n    width: 100%;\n    float: left;\n    margin: 10px;\n    border: 1px solid #999999;\n}\n\n.edit-section .title {\n    border-bottom: 1px solid #999999;\n    background: #dddddd;\n    color: #000000;\n    padding: 5px 12px;\n    font-size: 16px;\n    width: 100%;\n    float: left;\n    font-weight: 400;\n}\n\n.edit-section .content {\n    width: 100%;\n    float: left;\n    padding: 10px;\n    margin-top: 0;\n}\n\n.label-with-icon {\n    width: 95%;\n}\n\n#scenarioDescription {\n    margin-bottom: 20px;\n}\n\n.delete-button {\n    float: right;\n    margin-bottom: 0;\n}\n\n.delete-button:hover {\n    cursor: pointer;\n    color: #555;\n}\n\n.discount-container {\n    border: 1px solid #999999 !important;\n    margin: 0 0 10px !important;\n    padding: 8px 1px !important;\n    background: #ffffff !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/edit-simulation/edit-simulation.component.css
// module id = ../../../../../src/app/components/edit-simulation/edit-simulation.component.css
// module chunks = main